import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { GermanPensionEstimatorResultDTO } from '../dto/pension-estimator.dto.types';
import { PensionEstimatorResult } from '../model/pension-calculator';

export class PensionEstimatorMapper extends Mapper<PensionEstimatorResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    pensionEstimatorResultDTO: GermanPensionEstimatorResultDTO
  ): PensionEstimatorResult {
    return {
      status: pensionEstimatorResultDTO.Status,
      retirementPointsWest: pensionEstimatorResultDTO.RetirementPointsWest,
      retirementPointsEast: pensionEstimatorResultDTO.RetirementPointsEast,
      pointsWest: pensionEstimatorResultDTO.PointsWest,
      retirementDate: pensionEstimatorResultDTO.RetirementDate,
      pointsDate: pensionEstimatorResultDTO.PointsDate,
      pointsEast: pensionEstimatorResultDTO.PointsEast,
    };
  }
}
